module.exports = __webpack_public_path__ + "img/we_chat.62c42616.png";